export function setupTagSlider() {
    const tag_sliders = document.querySelectorAll(".tag_slider");
    if (!tag_sliders || document.querySelector("body").clientWidth < 767)
        return;

    for (const slider of tag_sliders) {
        const lis = slider.querySelectorAll(".tag_slider__tag");
        var lis_total_width = 0;
        for (const li of lis) lis_total_width += li.clientWidth;
        slider.dataset.lis_total_width = lis_total_width;
        if (lis_total_width > slider.clientWidth) {
            slider.classList.add("tag_slider--mostrar_navegacion_der");
            slider.classList.add("tag_slider--deshabilitar_navegacion_izq");
        } else {
            slider.classList.add("tag_slider--ocultar_navegacion");
        }

        const navegacion = slider.querySelectorAll(".tag_slider__navegacion");
        for (const nav of navegacion) {
            nav.addEventListener("click", function (e) {
                navegar(
                    slider,
                    this.classList.contains("tag_slider__navegacion--izq")
                );
            });
        }
    }
}

function navegar(slider, es_izq) {
    const listado = slider.querySelector(".tag_slider__listado");
    const gallery_items = listado.querySelectorAll("li");
    var total = 0;
    for (const gallery_item of gallery_items)
        total += gallery_item.clientWidth + 15;

    const distancia = gallery_items[0].clientWidth + 15;
    if (es_izq) {
        listado.scrollBy(distancia * -1, 0);
    } else {
        listado.scrollBy(distancia, 0);
    }
    setTimeout(() => {
        actualizarFlechas(slider);
    }, 250);
}

function actualizarFlechas(slider) {
    //si llegamos al final, sacamos la izquierda
    const slider_inner = slider.querySelector(".tag_slider__listado");
    if (slider_inner.scrollLeft > slider_inner.clientWidth + 100) {
        slider.classList.add("tag_slider--deshabilitar_navegacion_der");
    } else {
        slider.classList.remove("tag_slider--deshabilitar_navegacion_der");
    }

    if (slider_inner.scrollLeft > 0) {
        slider.classList.add("tag_slider--mostrar_navegacion_izq");
        slider.classList.remove("tag_slider--deshabilitar_navegacion_izq");
    } else {
        slider.classList.remove("tag_slider--mostrar_navegacion_izq");
        slider.classList.add("tag_slider--deshabilitar_navegacion_izq");
    }
    //si llegamos al principio, sacamos la derecha

    //slider.classList.add("tag_slider--mostrar_navegacion_izq");
}

function isTouchDevice() {
    return (
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
    );
}
